import { render, staticRenderFns } from "./GroupComponentizedModule.vue?vue&type=template&id=49c71dac&"
import script from "./GroupComponentizedModule.vue?vue&type=script&lang=js&"
export * from "./GroupComponentizedModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports